:host {
  display: block;
}

.#{$prefix}navigation-meta-wrapper {
  position: relative;
  width: 100%;
  height: 46px;
  border-bottom: 2px solid $navigation-meta-border-color;
  background-color: $navigation-meta-bg-color;
  z-index: 90;

  .#{$prefix}navigation-meta-inner {
    position: relative;
    width: 100%;
    height: 100%;
    max-width: $content-max-width-desktop-l;
    margin: 0 auto 0 auto;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: stretch;
    z-index: $mainNavigationZIndex;

    @include for-size(desktop-or-smaller) {
      max-width: $content-max-width-desktop;
    }
  }
}
